import CourseCard from "@/components/common/card/CourseCard";
import CommonImage from "@/components/common/image/CommonImage";
import SectionTitle from "@/components/common/section-title/SectionTitle";
import { Empty, Spin } from "antd";
import React from "react";
import { IoChevronDown } from "react-icons/io5";

export default function CoursePageCard({
  groups,
  selectedGruop,
  setActiveGroup,
  courses,
  hasMore,
  handleLoadMore,
  setting,
  selectedGroup,
  activeGroupKey,
  handleGroupClick,
  isFetchingNextPage
}) {

  console.log("selectedGroup 3",selectedGroup)
  return (
    <section className="course_section course-page_section section_padding bg-animation flex-1">
      <div className="container">
        <div className="course-section-card">
          {/* Section Title */}
          {setting && (
            <div className="section_title">
              <h2 className="title">
                <span className="w-8 h-8">
                  <CommonImage
                    src="/images/admission-icon/book-icon.png"
                    className="img-icon"
                    alt="Book Icon"
                  />
                </span>{" "}
                {selectedGroup?.name ?? ""}
              </h2>
              <p className="short-des">{setting?.course_sub_title}</p>
            </div>
          )}

          <div className="course_prorams">
            {groups?.map((item, index) => (
              <div
                key={index}
                className={`program-item cursor-pointer`}
                onClick={() => handleGroupClick(item)}
              >
                <div
                  className={`item-card ${
                    activeGroupKey == item.slug ? "active" : ""
                  }`}
                >
                  <div className="program-icon">
                    <CommonImage
                      src={item.image}
                      className="img-icon"
                      alt="Program Icon"
                    />
                  </div>
                  <div className="item-content">
                    <h4 className="title">{item.title}</h4>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="grid xl:grid-cols-3 sm:grid-cols-2 grid-cols-1 gap-3 md:gap-4 lg:gap-6 courses">
            {courses.length > 0 ? (
              courses.map((item, index) => {
                const pattern = [
                  "course-card-one",
                  "course-card-two",
                  "course-card-three",
                ];
                const bgClass = pattern[index % pattern.length];

                return (
                  <CourseCard key={index} course={item} bgClass={bgClass} />
                );
              })
            ) : (
              <div className="col-span-full">
                <Empty description="No course available" />
              </div>
            )}
          </div>
          {hasMore && courses.length > 0 && (
            <div className="mt-8 text-center">
              <button
                onClick={handleLoadMore}
                className="seemore-btn"
                disabled={isFetchingNextPage}
              >
                {isFetchingNextPage ? <Spin size="small" /> : "আরো দেখুন"}{" "}
                <IoChevronDown />
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
